var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportsAndAnalyticsFilledV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5008 9.99969C17.9608 9.99969 18.3383 9.62552 18.2925 9.16802C18.1004 7.25483 17.2526 5.46694 15.8928 4.10746C14.533 2.74797 12.7449 1.90055 10.8317 1.70886C10.3733 1.66302 10 2.04052 10 2.50052V9.16719C10 9.3882 10.0878 9.60016 10.2441 9.75644C10.4004 9.91273 10.6123 10.0005 10.8333 10.0005L17.5008 9.99969Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.93738C1.5 14.549 5.21604 18.2874 9.8 18.2874C12.8677 18.2874 15.5466 16.6131 16.9833 14.1234C17.2663 13.6329 16.8834 13.0604 16.3171 13.0604H9.2159C8.11133 13.0604 7.2159 12.1649 7.2159 11.0604V3.10569C7.2159 2.56087 6.6819 2.17717 6.19196 2.41546C3.41527 3.76593 1.5 6.62664 1.5 9.93738Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsAndAnalyticsFilledV2);
export default __webpack_public_path__ + "static/media/reportsAndAnalyticsFilledV2.8847ded2e1f647137e3847441e8db9e3.svg";
export { ForwardRef as ReactComponent };